import React from "react";
import { useNavigate } from "react-router-dom";
import strings from "translate/language";
import "./JustoBreadcrumb.css";

const Breadcrumb = (props) => {
  const {
    title,
    url,
    parentListing,
    titleactive,
    backurl = -1,
    isBackBtn = false,
    onBackClick,
    onParentClick,
  } = props;
  const navigate = useNavigate();

  const navigatpage = (navname) => {
    navigate(navname);
  };

  const handleParentClick = () => {
    if (typeof onParentClick === "function") {
      onParentClick(url);
      return;
    }
    if (url) navigatpage(url);
  };

  const handleBackClick = () => {
    if (typeof onBackClick === "function") {
      onBackClick(backurl);
      return;
    }
    navigatpage(backurl);
  };

  return (
    <div className="container-fluid justo-page-header">
      <div className="justo-page-header__row">
        {title ? <h1 className="justo-page-header__title">{title}</h1> : null}

        <nav aria-label="Breadcrumb" className="justo-page-header__nav">
          <ol className="justo-page-header__trail">
            <li className="justo-page-header__crumb">
              <button
                type="button"
                className="justo-page-header__link justo-page-header__link--home"
                aria-label="Dashboard"
                title="Dashboard"
                onClick={() => navigatpage("/dashboard")}
              >
                <i className="fa fa-home" aria-hidden="true" />
                <span>Home</span>
              </button>
            </li>
            {parentListing ? (
              <li className="justo-page-header__crumb">
                <button
                  type="button"
                  className="justo-page-header__link"
                  onClick={handleParentClick}
                >
                  {parentListing}
                </button>
              </li>
            ) : null}
            {titleactive ? (
              <li
                className="justo-page-header__crumb justo-page-header__current"
                aria-current="page"
              >
                {titleactive}
              </li>
            ) : null}
          </ol>
        </nav>

        {isBackBtn ? (
          <button
            type="button"
            className="justo-page-header__back"
            onClick={handleBackClick}
          >
            {strings.back}
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default Breadcrumb;
